module.exports = __webpack_public_path__ + "img/sup_deposit_ccpayment3.a0d1958d.jpg";